import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import { transformResponse, createRequest } from './util'; // import axios from 'axios'

/**
 * 普通request
 * @param {*} servicePath 服务路径
 * @param {*} api 接口名称
 * @param {*} params 请求体参数
 * @param {*} options request参数
 */

function request(servicePath, api, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    var _options$method;

    var isPost = ((_options$method = options.method) === null || _options$method === void 0 ? void 0 : _options$method.toLowerCase()) === 'post';
    var baseUrl = options.useCdn ? '//vipcdn.video.qq.com/rpc/' : '//vip.video.qq.com/rpc/';
    var withCredentials = options.withCredentials === false ? false : true;
    var queryStr = '?rpc_data=' + encodeURIComponent(JSON.stringify(params)); // const body = isPost ? { data: params } : { params: { rpc_data: params } }
    // axios
    //   .request({
    //     method: isPost ? 'post' : 'get',
    //     url: `/${servicePath}/${api}`,
    //     baseURL: options.baseURL || baseUrl,
    //     withCredentials: withCredentials,
    //     ...body,
    //     headers: {
    //       'Content-Type': 'application/json;charset=utf-8'
    //     },
    //     validateStatus: status => status === 200,
    //     transformResponse
    //   })
    //   .then(
    //     ({ data }) => {
    //       // 对请求做处理
    //       resolve(data)
    //     },
    //     err => {
    //       reject(err)
    //     }
    //   )

    var xhr = createRequest({
      url: "".concat(baseUrl).concat(servicePath, "/").concat(api).concat(isPost ? '' : queryStr),
      method: isPost ? 'post' : 'get',
      withCredentials: withCredentials // contentType: 'application/json;charset=utf-8'  // json的话会有options预检 axios就不会？

    }); // @ts-ignore

    if (isPost) {
      xhr.send(JSON.stringify(params));
    } else {
      xhr.send();
    }

    xhr.onreadystatechange = function () {
      //若响应完成且请求成功
      if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
        try {
          var data = transformResponse(xhr.response, xhr.getAllResponseHeaders());
          resolve(data);
        } catch (err) {
          reject(err);
        }
      }
    };
  });
}

export default request;